export const normalizeText = (value: unknown) => String(value ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-zA-Z0-9]/g, "")
  .toUpperCase();

export function cleanText(value: unknown): string {
  return String(value ?? "").trim();
}

export function optionalNumber(value: unknown): number | undefined {
  if (value === "" || value === null || value === undefined) return undefined;
  const number = Number(String(value).replace(",", "."));
  return Number.isFinite(number) ? number : undefined;
}

export function displayColor(value: unknown): string {
  const text = cleanText(value);
  if (!text) return text;
  if (text !== text.toUpperCase()) return text;
  return text.toLocaleLowerCase("pt-BR").replace(/(^|[\s-])\p{L}/gu, (match) => match.toLocaleUpperCase("pt-BR"));
}
